<div class="text-center">
  <p><i class="fa fa-check-circle text-success fa-3x"></i></p>
  <h3>{{'plan.verifying' | translate}}</h3>
  <span class="text-muted">{{'plan.redirecting' | translate}}</span>
  <app-loading [hideText]="true"></app-loading>
</div>
